import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "carouselExampleIndicators",
  class: "carousel slide",
  "data-ride": "carousel"
}
const _hoisted_2 = { class: "carousel-inner" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "carousel-item active"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  height: "200",
  src: "https://i.imgur.com/dnFaeQ9.png",
  class: "d-block w-100",
  alt: "..."
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  class: "carousel-control-prev",
  href: "#carouselExampleIndicators",
  role: "button",
  "data-slide": "prev"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "carousel-control-prev-icon",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Previous")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("a", {
  class: "carousel-control-next",
  href: "#carouselExampleIndicators",
  role: "button",
  "data-slide": "next"
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "carousel-control-next-icon",
    "aria-hidden": "true"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.images && _ctx.images.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.images, (img, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass(['carousel-item', { active: index === 0 }])
            }, [
              _createElementVNode("img", {
                src: img,
                class: "d-block w-100",
                alt: "...",
                height: "250"
              }, null, 8, _hoisted_3)
            ], 2))
          }), 128))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
    ]),
    _hoisted_7,
    _hoisted_8
  ]))
}